import React from 'react';
import RawHTML from '~/components/jsx-helpers/raw-html';
import { Countdown, Amount, GiveButton } from './common';
import './content-desktop.scss';
function Logo() {
    return (React.createElement("img", { className: "logo-color", src: "/dist/images/logo.svg", alt: "OpenStax logo", width: "354", height: "81" }));
}
function Basic({ headline, message, image, children }) {
    return (React.createElement("div", { className: "takeover-content desktop-only" },
        React.createElement("div", { className: "text-side" },
            React.createElement(Logo, null),
            React.createElement(RawHTML, { Tag: "h1", html: headline, id: "takeover-headline" }),
            React.createElement("div", { className: "message" }, message),
            children),
        React.createElement("div", { className: "picture-side", style: { backgroundImage: `url(${image})` } })));
}
function MessageBox({ buttonText, buttonUrl, headline, html }) {
    return (React.createElement(React.Fragment, null,
        React.createElement(GiveButton, { text: buttonText, url: buttonUrl }),
        React.createElement("div", { className: "message-box" },
            React.createElement("div", { className: "color-fill" }),
            React.createElement("div", { className: "text-content" },
                React.createElement("h2", null, headline),
                React.createElement(RawHTML, { html: html })))));
}
function GoalBox({ buttonText, buttonUrl, goalAmount, goalTime }) {
    return (React.createElement("div", { className: "goal-box" },
        React.createElement(Amount, { amount: goalAmount }),
        React.createElement("div", { className: "timer-side" },
            React.createElement("a", { className: "btn primary", href: buttonUrl }, buttonText),
            React.createElement("div", { className: "message" }, "help us meet our goal in the next"),
            React.createElement(Countdown, { goalTime: goalTime }))));
}
function Box({ data }) {
    return ({
        message: (React.createElement(MessageBox, { buttonText: data.buttonText, buttonUrl: data.buttonUrl, headline: data.boxHeadline, html: data.boxHtml })),
        goal: (React.createElement(GoalBox, { buttonText: data.buttonText, buttonUrl: data.buttonUrl, goalAmount: data.goalAmount, goalTime: data.goalTime }))
    }[data.messageType] || React.createElement("h1", null,
        "OOPS, ",
        data.messageType));
}
export default function DesktopContent({ data }) {
    return (React.createElement(Basic, { headline: data.headline, message: data.message, image: data.image },
        React.createElement(Box, { data: data })));
}
